import type { IUser } from '@pulse/shared';

import { apiFetch } from '../../../lib/api-client';
import { extractErrorMessage } from '../../../lib/api-error.util';

const BASE = '/api/v1/auth';

export async function fetchCurrentUser(): Promise<IUser> {
  const res = await apiFetch(`${BASE}/me`);
  if (!res.ok) throw new Error(`Not authenticated: ${res.status}`);
  return res.json() as Promise<IUser>;
}

export async function logout(): Promise<void> {
  await apiFetch(`${BASE}/logout`, { method: 'POST' });
}

// Self-service counterpart of the admin-facing updateUserOrganization() in the
// access-management feature — PATCH /users/me/organization always resolves the acting user
// from the JWT (req.user.userId), never from a client-supplied id. Backs the BU/Management
// login gate (OrganizationGateDialog) and returns the self-facing IUser shape.
export async function updateMyOrganization(data: {
  isManagement: boolean;
  businessUnitId?: string | null;
}): Promise<IUser> {
  const res = await apiFetch('/api/v1/users/me/organization', {
    method: 'PATCH',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify(data),
  });
  if (!res.ok) throw new Error(await extractErrorMessage(res, 'Failed to update your profile'));
  return res.json() as Promise<IUser>;
}
